export default __webpack_public_path__ + "static/media/BEcerti.56cb6acf.pdf";